export function valueMap<T extends string>(values: readonly T[]): { readonly [K in T]: K } {
  return Object.fromEntries(values.map((value) => [value, value])) as { readonly [K in T]: K };
}

export const TRANSACTION_STOCK_EFFECT_VALUES = ["increase", "decrease", "computed"] as const;

export const CONTACT_TYPE_VALUES = ["supplier", "purchaser", "supplier_and_purchaser"] as const;

export const ORDER_STATUS_VALUES = ["requested", "ordered", "fulfilled", "cancelled"] as const;

export const CHANGE_HISTORY_TYPE_VALUES = ["CREATED", "UPDATED", "DELETED"] as const;

export const CHANGE_HISTORY_FIELD_VALUES = ["amount", "document", "splitFrom"] as const;

export const AUDIT_ENTITY_TYPE_VALUES = ["chemical", "order", "document"] as const;

export const ORDER_DIRECTION_VALUES = ["purchase", "sale"] as const;

export const ORDER_ACTION_VALUES = ["place", "fulfill", "undo", "cancel"] as const;

export const ORDER_HISTORY_EVENT_VALUES = [
  "imported",
  "requested",
  "placed",
  "fulfilled",
  "cancelled",
  "reopened",
  "payment_recorded",
  "payment_amended",
  "payment_deleted",
  "invoice_recorded",
  "invoice_amended",
  "invoice_deleted",
  "receipt_recorded",
  "shipment_recorded",
  "movement_amended",
  "movement_deleted",
  "document_uploaded",
  "document_replaced",
  "document_deleted",
  "amended",
  "returned",
  "credit_memo_recorded",
  "credit_memo_deleted",
  "document_previewed",
  "document_mark_applied",
  "document_generated",
  "document_corrected",
  "document_viewed",
  "document_download_requested",
] as const;

export const DOCUMENT_AUDIT_EVENT_VALUES = [
  "mark_uploaded",
  "mark_replaced",
  "mark_deactivated",
  "company_updated",
  "address_saved",
  "address_archived",
  "action_denied",
  "action_failed",
] as const;

export const ADDRESS_USE_VALUES = ["billing", "shipping"] as const;

export const DOCUMENT_AUDIT_OUTCOME_VALUES = ["succeeded", "granted", "denied", "failed"] as const;

export const DOCUMENT_TEMPLATE_KEY_VALUES = ["packingSlip", "invoice", "purchaseOrder", "releaseOrder"] as const;
export const MARK_KIND_VALUES = ["stamp", "logo"] as const;
export const APPLIED_MARK_VALUES = ["stamp", "signature"] as const;
export const TEMPLATE_FIELD_KIND_VALUES = ["text", "date", "multiline"] as const;
export const TEMPLATE_PARTY_SOURCE_VALUES = ["issuer", "contact"] as const;
export const TEMPLATE_FIELD_SOURCE_VALUES = ["shipmentCarrier", "shipmentDate", "orderCustomerPo", "paymentTerms"] as const;
export const DOCUMENT_LINE_KEY_VALUES = ["description", "quantity", "unit", "batchNumber", "packaging", "unitPrice", "amount"] as const;
export const DOCUMENT_ACCESS_KIND_VALUES = ["view", "download"] as const;
export const FACT_SOURCE_VALUES = ["order", "contact", "shipment", "company"] as const;
export const DOCUMENT_GENERATION_ACTION_VALUES = [
  "readConfig", "prefill", "listGenerated", "renderLive", "createPreview", "viewPreview", "savePreview", "viewDocument", "downloadDocument",
  "listMarks", "uploadMark", "replaceMark", "deactivateMark", "viewMark", "readCompany", "saveCompany", "saveAddress", "archiveAddress",
] as const;
export const MARK_IMAGE_FORMAT_VALUES = ["png", "jpeg"] as const;

export const DASHBOARD_WIDGET_KIND_VALUES = ["stat", "bar"] as const;
export const DASHBOARD_WIDGET_STATUS_VALUES = ["loading", "error", "empty", "ready"] as const;
export const TABLE_SORT_DIRECTION_VALUES = ["asc", "desc"] as const;
